import {
    CORE_LOAD_CUSTOMER_REQUEST,
    CORE_LOAD_CUSTOMER_SUCCESS,
    CORE_LOAD_CUSTOMER_FAILURE,
    REQUEST_STATE
} from '../types'

const requestState = REQUEST_STATE

export default {
    customerData: (state = requestState, action) => {
        switch (action.type) {
            case CORE_LOAD_CUSTOMER_REQUEST:
                return state 
            case CORE_LOAD_CUSTOMER_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload
                    if (result && datas) {
                        return datas
                    } else return {}
                } else {
                    return {}
                }
            case CORE_LOAD_CUSTOMER_FAILURE:
                return {}
            default:
                return state
        }
    },
}


// WEBPACK FOOTER //
// ./src/app/redux/reducers/customerData.js